import React, { useContext } from "react";
import { AppContext } from "../context/AppProvider";
import Swal from "sweetalert2";

const useApp = () => {
  /**
   *
   * @param {string} msg
   * @param {string} icon posible values: "info, error, success, warning"
   * @returns displays a sweetalert message
   */
  const showAlert = async (msg = "Loading....", icon = "info") => {
    return Swal.fire({
      position: "top",
      icon: icon,
      text: msg,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const convertCurrency = (value, currency = "GHS") => {
    try {
      return new Intl.NumberFormat("en", {
        style: "currency",
        currency: currency || "GHS",
        currencyDisplay: "narrowSymbol",
      }).format(value || 0);
    } catch (error) {
      return value;
    }
  };

  return { ...useContext(AppContext).app, showAlert, convertCurrency };
};

export default useApp;
